import { render, staticRenderFns } from "./TravelerCategories.vue?vue&type=template&id=3625b5b3&scoped=true"
import script from "./TravelerCategories.vue?vue&type=script&lang=js"
export * from "./TravelerCategories.vue?vue&type=script&lang=js"
import style0 from "./TravelerCategories.vue?vue&type=style&index=0&id=3625b5b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3625b5b3",
  null
  
)

export default component.exports